export const SHRANK_SITE_NAV_HEIGHT = 50
